import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Lock, Award } from 'lucide-react';
const testimonials = [{
  quote: 'Mi hija ahora practica sola porque siente que está jugando.',
  name: 'Mariana G.',
  color: 'bg-pastel-blue'
}, {
  quote: 'Las actividades son claras y muy entretenidas.',
  name: 'Laura P.',
  color: 'bg-pastel-mint'
}, {
  quote: 'Lo usamos tanto en casa como en el aula.',
  name: 'Daniela R.',
  color: 'bg-pastel-yellow'
}, {
  quote: 'Mi hijo mejoró muchísimo su escritura.',
  name: 'Sofía M.',
  color: 'bg-pastel-lilac'
}, {
  quote: 'Vale cada peso invertido.',
  name: 'Paula C.',
  color: 'bg-pastel-coral'
}, {
  quote: 'Mucho más completo de lo que esperaba.',
  name: 'Romina T.',
  color: 'bg-pastel-blue'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-white" data-id="element-246">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-248">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4" data-id="element-249">
            Lo que dicen otras familias
          </h2>
          <div className="w-24 h-1.5 bg-pastel-mint mx-auto rounded-full" data-id="element-250"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20" data-id="element-251">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 rounded-2xl p-6 border border-slate-100 flex flex-col" data-id="element-252">
              <div className="flex gap-1 mb-4" data-id="element-253">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-254" />)}
              </div>
              <p className="text-slate-700 italic mb-6 flex-1" data-id="element-255">"{t.quote}"</p>
              <div className="flex items-center gap-3" data-id="element-256">
                <div className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center text-slate-800 font-bold text-sm`} data-id="element-257">
                  {t.name.charAt(0)}
                </div>
                <span className="font-bold text-slate-800" data-id="element-258">— {t.name}</span>
              </div>
            </motion.div>)}
        </div>

        {/* Trust Block */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-pastel-blueLight/30 rounded-3xl p-8 md:p-12 text-center max-w-3xl mx-auto border border-pastel-blueLight" data-id="element-259">
          <h3 className="text-2xl font-bold text-slate-800 mb-4" data-id="element-260">
            Compra con tranquilidad
          </h3>
          <p className="text-lg text-slate-600 mb-8" data-id="element-261">
            Acceso inmediato al material digital y actualizaciones futuras del
            contenido.
          </p>
          <div className="flex flex-wrap justify-center gap-8" data-id="element-262">
            <div className="flex flex-col items-center gap-2" data-id="element-263">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-pastel-mint" data-id="element-264">
                <ShieldCheck className="w-6 h-6" data-id="element-265" />
              </div>
              <span className="text-sm font-bold text-slate-600" data-id="element-266">
                Pago Seguro
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-267">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-pastel-blue" data-id="element-268">
                <Lock className="w-6 h-6" data-id="element-269" />
              </div>
              <span className="text-sm font-bold text-slate-600" data-id="element-270">
                Privacidad
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-271">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-pastel-yellow" data-id="element-272">
                <Award className="w-6 h-6" data-id="element-273" />
              </div>
              <span className="text-sm font-bold text-slate-600" data-id="element-274">
                Calidad Garantizada
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}